module.exports = __webpack_public_path__ + "img/invite-en.3239df18.png";